import React from "react";
import { FormControl, Col, Row, Card } from "react-bootstrap";
import {
  FaFilter,
  FaMoneyBillAlt,
  FaArrowLeft,
  FaArrowRight,
  FaEllipsisV,
} from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import apiEndPoints from "../../../../componets/json/apiEndPoints.json";
import ModalAdminUser from "./components/modalUser";

class AdminUsers extends React.Component {
  state = {
    filterValue: "",
    loading: {
      status: false,
      text: "",
    },
    users: [],
    open: false,
    openId: -1,
  };

  filterFunc = (data) => {
    const fulltext = JSON.stringify(data);
    return (
      fulltext.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) > -1
    );
  };

  getUsers = async () => {
    this.setState({ loading: { ...this.state.loading, status: true } });
    const _res = await this.props._api({
      ...this.props,
      method: apiEndPoints.britex.Admin.get.users.method,
      endpoint: apiEndPoints.britex.Admin.get.users.endPoint,
      param: "",
    });
    this.setState({ loading: { ...this.state.loading, status: false } });
    if (_res.status == 200) {
      this.setState({ users: JSON.parse(this.props._decrypt(_res.data)) });
    }
  };

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FiUsers className="c-placeholder c-green" />,
      Title: "Administrace uživatelů",
      SubTitle: "",
    });
    this.getUsers();
  }

  render() {
    const { Bs, VARIANT, _placeholder } = this.props;
    return (
      <>
        <ModalAdminUser
          show={this.state.open}
          hide={() => this.setState({ open: false })}
          users={this.state.users}
          idx={this.state.openId}
          {...this.props}
        />
        <div class="p-3 mb-4 bg-uni rounded">
          <div class="d-flex justify-content-between align-items-start align-items-md-center">
            <div>
              <span class="text-secondary mr-1 me-2">Použité filtry:</span>
              <span>
                <strong>
                  {this.state.filterValue == ""
                    ? "Bez filtru"
                    : this.state.filterValue}
                </strong>
              </span>
            </div>
            <Col xs={4} className="d-flex justify-content-end">
              <Bs
                formcontrol
                placeholder="Hledat"
                value={this.state.filterValue}
                onChange={(e) => this.setState({ filterValue: e.target.value })}
              />
            </Col>
          </div>
        </div>

        {this.state.loading.status && (
          <Bs row>
            <Bs col>
              <Bs card variant={VARIANT.WHITE} className="lb-3-secondary">
                <Bs cardbody>
                  <_placeholder
                    line={[
                      {
                        itms: [
                          {
                            size: 1,
                          },
                          {
                            size: 7,
                          },
                          {
                            size: 3,
                          },
                          {
                            size: 1,
                          },
                        ],
                      },
                    ]}
                  />
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        )}

        {this.state.users.filter(this.filterFunc).map((e, idx) => (
          <Row className="mb-2">
            <Col>
              <Card
                className="bg-white lb-3-secondary cursor-pointer"
                onClick={() => this.setState({ open: true, openId: e.id })}
              >
                <Row className="mt-1 mb-1 ms-1 me-1">
                  <Col xs={1}>
                    <Row>
                      <strong>{e.id}</strong>
                    </Row>
                  </Col>
                  <Col xs={7}>
                    <Row>
                      <strong>{e.userName ? e.userName : e.email}</strong>
                    </Row>
                    <Row>
                      <small>{e.email}</small>
                    </Row>
                  </Col>
                  <Col xs={3}>
                    <Row>
                      <small className="c-black">
                        {e.firstName
                          ? e.firstName
                          : "Jméno" + " " + e.surName
                          ? e.surName
                          : "Příjmení"}
                      </small>
                    </Row>
                  </Col>
                  <Col
                    xs={1}
                    className="d-flex justify-content-end align-items-center"
                  >
                    <small className="c-black">{e.type}</small>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        ))}
      </>
    );
  }
}

export default AdminUsers;
